import { initializeChatUser } from "common/sharedFunctions";
import { client } from "common/sharedFunctions";
import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import {
  Chat,
  Channel,
  ChannelList,
  Window,
  ChannelHeader,
  MessageList,
  MessageInput,
  Thread,
} from "stream-chat-react";
import "stream-chat-react/dist/css/v2/index.css";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const ChatComponent = () => {
  const auth = useSelector((state) => state.auth);
  const theme = useTheme();
  const isMobile = useMediaQuery('(max-width:600px)');
  const [showChannel, setShowChannel] = useState(false);
  const [activeChannel, setActiveChannel] = useState(null);

  const filters = { members: { $in: [auth?.profile?.uid] }, type: "messaging" };
  const options = { presence: true, state: true };
  const sort = { last_message_at: -1 };

  useEffect(() => {
    initializeChatUser(auth?.profile);
  }, [auth]);

  if (!client) return <div>Loading...</div>;

  if (isMobile) {
    return (
      <Chat client={client}>
        <div style={{ height: "calc(100vh - 120px)", overflow: "hidden" }}>
          {!showChannel ? (
            <div style={{ height: "100%", overflowY: "auto" }}>
              <ChannelList
                sort={sort}
                filters={filters}
                options={options}
                onSelect={(channel) => {
                  setActiveChannel(channel);
                  setShowChannel(true);
                }}
                customActiveChannel={activeChannel?.id}
              />
            </div>
          ) : (
            <Channel channel={activeChannel}>
              <Window>
                <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e2e8f0', padding: '4px 0' }}>
                  <IconButton onClick={() => setShowChannel(false)} sx={{ ml: 1 }}>
                    <ArrowBackIcon />
                  </IconButton>
                  <ChannelHeader />
                </div>
                <div style={{ flex: 1, overflow: "hidden" }}>
                  <MessageList />
                </div>
                <MessageInput />
              </Window>
              <Thread />
            </Channel>
          )}
        </div>
      </Chat>
    );
  }

  return (
    <Chat client={client}>
      <div style={styles.container}>
        <div style={styles.channelList}>
          <ChannelList sort={sort} filters={filters} options={options} />
        </div>

        <div style={styles.channelContainer}>
          <Channel>
            <Window>
              <ChannelHeader />
              <div style={{ height: "80vh" }}>
                <MessageList />
              </div>
              <MessageInput />
            </Window>
            <Thread />
          </Channel>
        </div>
      </div>
    </Chat>
  );
};

const styles = {
  container: {
    display: "flex",
    height: "calc(100vh - 70px)",
    overflow: "hidden",
  },
  channelList: {
    flex: "0 0 35%",
    maxWidth: "35%",
    height: "100%",
    overflowY: "auto",
    borderRight: "1px solid #e2e8f0",
  },
  channelContainer: {
    flex: 1,
    height: "100%",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
};

export default ChatComponent;
